module.exports = __webpack_public_path__ + "img/icon_card08.d7298a88.png";